import { readDataByContentItemIds, displayContentItem } from "../../../apis/httpHelper";
import qweBaseField from "../BaseField";
import { singleDataConvert } from "../../../common/commonHelper";

export default {
    mixins:[qweBaseField],
    data:function(){
        return {
            requestContentType:"",
            loading:true,
            displayFields:[],
            formFields:[],
            buttonName:"",
            selectItems:[],
            gridId:"",
            filters:{},

            showFormState:false,
            visibleState:false,
            gridState:false,
            gridSelectItems:[],
            selectItems:[]
        }
    },
    created:function(){
        let self = this;
        this.buttonName = this.selfSetting.ButtonName;
        this.displayFields = this.selfSetting.DisplayFields;
        this.formFields = this.selfSetting.FromFields;

        self.getAllData();
        this.$watch("data." + this.name, function () {
            self.getAllData();
        })
    },

    methods:{
        getAllData:function(){
            if(!this.selfSetting.IsShowValue){
                return;
            }
            if(this.data[this.name] == undefined || this.data[this.name] == null){
                return;
            }
            else{
                readDataByContentItemIds(new Array(this.data[this.name]),this.displayFields, true)
                    .then(x=>{
                        let fields = x.Result.fieldDefitions;
                        x.Result.data.forEach(dataItem=> {
                            fields.forEach(field=>{
                                dataItem[field.Name] = singleDataConvert(dataItem[field.Name], field.Type);
                            })
                        })
                        this.selectItems = x.Result.data;
                    })
            }
        },

        showSelectZone:function(){
            if(this.disabled){
                return;
            }
            else{
                let OptionFunc = new Function("Context","Content","self",this.selfSetting.GridOptions);
                let options = OptionFunc(this.buildFormContext(), this.data, this);
                this.gridId = options.GridId;
                this.filters = options.Filter;
                this.gridState = true;
            }
        },

        showFormDetial:function(contentItemId){
            displayContentItem(contentItemId,this.formFields).then(x=> {
                this.propDatas = x.Result;
                this.visibleState = true;
            })
        },

        selectEvent:function(selects){
            this.gridSelectItems = selects;
        },

        initGrid:function(){
            
        },

        deleteItem:function(){
            this.data[this.name] = "";
            this.selectItems = []
        },

        sumbit:function(){
            this.data[this.name] = this.gridSelectItems[0].ContentItemId;
            this.getAllData();
            this.gridState = false;
        }
    }
}